import {
  AddonContactButtonState,
  ContactButtonEditPayload,
  ContactButtonIconOption,
  ContactButtonPersonalizationOption,
  ContactButtonPositionOption,
} from "../entities/contact-button.entities";

export enum ContactButtonPersonalizationOptionId {
  None = "none",
  Configuration = "configuration",
  Messages = "messages",
  Position = "position",
  Icon = "icon",
  Color = "color",
}
export const CONTACT_BUTTON_CONFIGURATION_OPTIONS: ContactButtonPersonalizationOption[] =
  [
    {
      id: ContactButtonPersonalizationOptionId.Configuration,
      icon: "puzzle-piece",
      text: "config",
    },
    {
      id: ContactButtonPersonalizationOptionId.Messages,
      icon: "comments-outline",
      text: "messages",
    },
    {
      id: ContactButtonPersonalizationOptionId.Position,
      icon: "full-screen",
      text: "position",
    },
    {
      id: ContactButtonPersonalizationOptionId.Icon,
      icon: "image",
      text: "icon",
    },
    {
      id: ContactButtonPersonalizationOptionId.Color,
      icon: "light-paintBrush",
      text: "color",
    },
  ];

export enum ContactButtonIconName {
  One = "talk",
  InstagramOne = "instagram-outline",
  Two = "chat-circle-text",
  Three = "chat-circle-dots",
  Four = "chats-circle",
}
export const CONTACT_BUTTON_ICONS: ContactButtonIconOption[] = [
  { text: "1", icon: ContactButtonIconName.One },
  { text: "2", icon: ContactButtonIconName.Two },
  { text: "3", icon: ContactButtonIconName.Three },
  { text: "4", icon: ContactButtonIconName.Four },
];

export const INSTAGRAM_CONTACT_BUTTON_ICONS: ContactButtonIconOption[] = [
  { text: "1", icon: ContactButtonIconName.InstagramOne },
  { text: "2", icon: ContactButtonIconName.Two },
  { text: "3", icon: ContactButtonIconName.Three },
  { text: "4", icon: ContactButtonIconName.Four },
];

export enum GeneralConfigStep {
  Visibility = "visibility",
  Whatsapp = "whatsapp",
  Instagram = "instagram",
}

export enum ContactButtonPositionXAxis {
  Left = "left-x",
  Center = "center-x",
  Right = "right-x",
}
export enum ContactButtonPositionYAxis {
  Center = "center-y",
  Bottom = "bottom-y",
}
export const CONTACT_BUTTON_POSITION_X_AXIS_OPTIONS: ContactButtonPositionOption[] =
  [
    {
      id: ContactButtonPositionXAxis.Left,
      text: "left",
      icon: "light-align-left",
    },
    {
      id: ContactButtonPositionXAxis.Center,
      text: "center",
      icon: "light-align-center-horizontal",
    },
    {
      id: ContactButtonPositionXAxis.Right,
      text: "right",
      icon: "light-align-right",
    },
  ];
export const CONTACT_BUTTON_POSITION_Y_AXIS_OPTIONS: ContactButtonPositionOption[] =
  [
    {
      id: ContactButtonPositionYAxis.Center,
      text: "middle",
      icon: "align-vertical-center",
    },
    {
      id: ContactButtonPositionYAxis.Bottom,
      text: "bottom",
      icon: "align-vertical-bottom",
    },
  ];

export enum DefaultContactButtonColors {
  icon = "#FFFFFF",
  background = "#4CCA5B",
  instagram_background = "#E1306C",
}

export const CONTACT_BUTTON_COLOR_OPTIONS: string[] = [
  "custom",
  "#25D366",
  "#01C0A6",
  "#128D7F",
  "#065E55",
];

export const INSTAGRAM_CONTACT_BUTTON_COLOR_OPTIONS: string[] = [
  "custom",
  "#E56969",
  "#C1558B",
  "#8A49A1",
  "#FFBD67",
];

export enum ContactButtonMessageWordsToReplace {
  StoreName = "[store_name]",
  StoreLink = "[store_link]",
  ProductName = "[product_name]",
  ProductLink = "[product_link]",
}

export enum ContactButtonEvents {
  SelectButton = "select_button",
  ViewScreen = "view_screen",
  SelectLink = "select_link",
  SelectSaveConfiguration = "select_save_configuration",
}

export const initialContactButtonContextValue: AddonContactButtonState = {
  token: "",
  hasAddon: false,
  isDirty: false,
  countries: [],
  notification: { text: "", type: "" },
  oldButtonConfig: {} as ContactButtonEditPayload,
  buttonConfig: {} as ContactButtonEditPayload,
  contactButtonConfigurationOptions: CONTACT_BUTTON_CONFIGURATION_OPTIONS,
  selectedOptionId: ContactButtonPersonalizationOptionId.None,
  generalConfigStep: GeneralConfigStep.Visibility,
};
